import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgForwardArrowSmall = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 14,
	viewBox: "0 0 20 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12.7249 13.675L11.6749 12.625L16.5499 7.74995H0.399902V6.24995H16.5499L11.6749 1.37495L12.7249 0.324951L19.4249 6.99995L12.7249 13.675Z",
		fill: "#4391FF"
	})]
});
const ForwardRef = forwardRef(SvgForwardArrowSmall);
export { ForwardRef as ReactComponent };
